import dynamic from 'next/dynamic'

const BelowTheFold = dynamic(
  () =>
    import('../components/variant_2/BelowTheFold').then((m) => m.BelowTheFold),
  {
    ssr: false,
  },
)

export const Variant2PageContent = () => (
  <div>
    <div>{`Hero`}</div>
    <div>{`Skills You'll Learn`}</div>

    <BelowTheFold />

    <div>{`Sticky Footer`}</div>
  </div>
)
